import { render, staticRenderFns } from "./tax-rate-form.vue?vue&type=template&id=04a02a2d"
import script from "./tax-rate-form.vue?vue&type=script&lang=js"
export * from "./tax-rate-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports